var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContracts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.749,
    height: 17.53,
    viewBox: "0 0 12.749 17.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contracts",
    transform: "translate(-218.137 -158.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M228.767,168.18v-2.933a1.586,1.586,0,0,0-.268.212l-3.847,3.847a1.585,1.585,0,0,0-.212.268h2.933a1.4,1.4,0,0,0,1.394-1.394Z",
    transform: "translate(-6.048 -6.043)",
    fill: "#727376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M229.293,158.95h-5.715a1.583,1.583,0,0,0-.461.076v3.111a1.8,1.8,0,0,1-1.793,1.793h-3.111a1.583,1.583,0,0,0-.076.461v10.5a1.594,1.594,0,0,0,1.594,1.594h9.562a1.594,1.594,0,0,0,1.594-1.594V160.544a1.594,1.594,0,0,0-1.594-1.594Zm-3.187,1.394H227.7a.2.2,0,1,1,0,.4h-1.594a.2.2,0,0,1,0-.4ZM224.512,171.1h-4.781a.2.2,0,1,1,0-.4h4.781a.2.2,0,1,1,0,.4Zm4.781,3.984h-3.984a.2.2,0,1,1,0-.4h.818a.973.973,0,0,1-.22-.6,1,1,0,1,1,1.992,0,.974.974,0,0,1-.22.6h1.615a.2.2,0,0,1,0,.4Zm0-5.578h-9.562a.2.2,0,1,1,0-.4h9.562a.2.2,0,0,1,0,.4Zm0-1.594h-9.562a.2.2,0,1,1,0-.4h9.562a.2.2,0,0,1,0,.4Zm0-1.594h-7.968a.2.2,0,0,1,0-.4h7.968a.2.2,0,0,1,0,.4Zm0-3.984h-3.187a.2.2,0,0,1,0-.4h3.187a.2.2,0,0,1,0,.4Z",
    transform: "translate(0)",
    fill: "#727376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M421.593,519.657a.6.6,0,1,1-.6-.6.6.6,0,0,1,.6.6",
    transform: "translate(-194.093 -345.568)",
    fill: "#727376"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.5230209cb4e7b65dd682eb7c67708392.svg";
export { ForwardRef as ReactComponent };